import PropTypes from 'prop-types';
import React from 'react';
import useTranslate from '../../hooks/useTranslate/useTranslate';
import styles from './RoomsNotAvailableMessage.module.css';

const RoomsNotAvailableMessage = ({
  ratePlanCodeApplied,
  specialCodeValue,
}) => {
  const { t } = useTranslate();

  let message;
  if (ratePlanCodeApplied) {
    message = t('This offer is not available for your selected dates.');
  } else if (
    (specialCodeValue === 'COMP' || specialCodeValue === 'DISC') &&
    !ratePlanCodeApplied
  ) {
    message = `${t('This rate is not available for the selected dates.')} ${t(
      'Please try re-selecting new dates.'
    )}`;
  } else {
    message = t('Please contact the hotel directly for assistance.');
  }

  return (
    <div
      className={styles.RoomsNotAvailableMessage__container}
      aria-label="There are no available rooms"
    >
      <div data-testid="message-for-unavailable-rooms">{message}</div>
    </div>
  );
};

RoomsNotAvailableMessage.propTypes = {
  ratePlanCodeApplied: PropTypes.bool,
  specialCodeValue: PropTypes.string,
};

export default RoomsNotAvailableMessage;
